import { Router } from '@angular/router';

export enum ClickType {
  LEFT = 1,
  MIDDLE = 2,
  CTRL = 3
}

export class NavigationHelper {



  constructor(private router: Router) {

  }
  // user forceWindow on external links that router can't handle
  public Navigate(clickTypes: ClickType[], navURL: string, clickEvent: MouseEvent, forceWindow: boolean = false) {
    if (clickTypes.indexOf(ClickType.CTRL, 0) > -1 && this.IsCTRLClick(clickEvent)) {
      window.open(navURL);
    } else
    if (clickTypes.indexOf(ClickType.LEFT,  0) > -1 && this.IsLeftClick(clickEvent)) {
      if(!forceWindow) {
        this.router.navigate([navURL]);
      } else {
        window.open(navURL);
      }
    } else
    if (clickTypes.indexOf(ClickType.MIDDLE, 0) > -1 && this.IsMiddleClick(clickEvent)) {
      window.open(navURL);
    }
  }

  public IsLeftClick(clickEvent: MouseEvent) {
    return clickEvent.which === 1;
  }

  public IsMiddleClick(clickEvent: MouseEvent) {
    return clickEvent.which === 2;
  }

  public IsCTRLClick(clickEvent: MouseEvent) {
    return clickEvent.which === 1 && clickEvent.ctrlKey;
  }
}
